// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M21.7197 1.82227L22.4385 11.1748L10.9746 22.6387L1.0752 12.7393L12.6865 1.12793L21.7197 1.82227ZM17.3887 6.25488C16.4123 5.2785 14.8299 5.2785 13.8535 6.25488C12.8772 7.23127 12.8772 8.81368 13.8535 9.79004C14.8299 10.7664 16.4123 10.7664 17.3887 9.79004C18.3651 8.81366 18.365 7.23127 17.3887 6.25488Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M23 16V18H19V16H23Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M23 20V22H15V20H23Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-discount-list-filled')
export default class DiscountListFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'discount-list-filled',
    }
  }
}
